import '../../../resources/css/admin_style.css';
import styles from './component.module.css';
import { useState } from 'react';
import DeleteAccountsModal from './modal/DeleteAccountsModal';
import { InnocodeTextButton } from '@intsoft/innocode-core';

/**
 * 회원 탈퇴 판넬
 * @param callback
 * @param delay
 */
function DeleteAccountsPanel({ user, onUserUpdate, doLogout }) {
  const [showModal, setShowModal] = useState(false);

  const handleDeleteAccountModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };


  return (
    <>
      <div className={styles.deleteAccountCard}>
        <InnocodeTextButton
          size="sm"
          onClick={handleDeleteAccountModal}
          textColor={'var(--status-negative, #f83a3a)'}
        >
          계정 삭제
        </InnocodeTextButton>
      </div>

      {showModal && (
        <DeleteAccountsModal onClose={handleCloseModal} user={user} doLogout={doLogout} />
      )}
    </>
  );
}

export default DeleteAccountsPanel;